/**
 * All helpers operate in local time (not UTC) to match UI expectations.
 */

export function startOfDay(d: Date) {
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function endOfDay(d: Date) {
  const date = new Date(d);
  date.setHours(23, 59, 59, 999);
  return date;
}

/** Week starts Monday (ISO-ish). */
export function startOfWeekMonday(d: Date) {
  const date = startOfDay(d);
  const day = date.getDay(); // 0 Sun..6 Sat
  const diff = (day === 0 ? -6 : 1) - day;
  date.setDate(date.getDate() + diff);
  return date;
}

export function startOfMonth(d: Date) {
  const date = startOfDay(d);
  date.setDate(1);
  return date;
}

export function endOfMonth(d: Date) {
  // last day of month: day 0 of next month
  const date = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return endOfDay(date);
}

export function startOfYear(d: Date) {
  const date = startOfDay(d);
  date.setMonth(0, 1);
  return date;
}

export function endOfYear(d: Date) {
  const date = new Date(d.getFullYear(), 11, 31);
  return endOfDay(date);
}

export function addDays(d: Date, days: number) {
  const date = new Date(d);
  date.setDate(date.getDate() + days);
  return date;
}

export function addMonths(d: Date, months: number) {
  const date = new Date(d);
  date.setMonth(date.getMonth() + months, 1);
  return date;
}

export function formatMonthShort(d: Date) {
  // "Jan ’26" in many locales; exact punctuation depends on locale
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    year: "2-digit",
  }).format(d);
}

export function formatYear(d: Date) {
  return String(d.getFullYear());
}

// If caller already passed 23:59:59.999, +1ms pushes to next instant.
export function nextInstantIso(toInclusiveIso: string) {
  const d = new Date(toInclusiveIso);
  return new Date(d.getTime() + 1).toISOString();
}
